import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Form, TextArea } from 'semantic-ui-react';

import { SummaryEditor, AutoSentence, NotGeneratedYet, RatingIncomplete } from '../../components';

const moments = date => moment(new Date(date)).format('DD/MM/YYYY hh:mm:ss a');

class LargeBrandSentenceEditor extends Component {
  constructor(props) {
    super(props);
    this.brandId = this.props.brandId
    this.state = {
      isEditing: false,
      isGeneratingSentence: false,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.sentence && nextProps.sentence !== this.props.sentence) {
      this.setState({
        sentence: nextProps.sentence
      })
    }
  }
  
  navigateTo = (route) => {
    switch (route) {
    case 'brandPage':
      this.props.history.push(`/brandLanding/${this.brandId}`);
      break;
    case 'ratingPage':
      this.props.history.push(`/env-standards-compliance/${this.brandId}`);
      break;
    case 'next': 
      this.props.history.push(`/brandLanding/${this.brandId}`)
    default:
    }
  } 

  openEditor = () => {
    this.setState({ isEditing: true });
  }

  closeEditor = () => {
    this.setState({ isEditing: false });
  }
  
  openAutoSentenceEditor = () => {
    this.setState({ isGeneratingSentence: true });
  }

  closeAutoSentenceEditor = () => {
    this.setState({ isGeneratingSentence: false });
  }

  handleSaveAndNext = (newSentence) =>  {
    this.handleSave(newSentence);
    this.navigateTo("next");
  }

  handleSave = (newSentence) => {
    this.props.onSave(newSentence);
    this.closeEditor();
    this.closeAutoSentenceEditor();
  }

  handleCancel = () => {
    this.props.onCancel();
    this.closeEditor();
    this.closeAutoSentenceEditor();
  }

  render = () => {
    let sentence = this.props.sentence
    return (
      <div>
        {
          sentence.rating_status === 'incomplete'
            && <RatingIncomplete
              title={"The Brand Rating needs to be completed before generating an Auto Sentence"}
              onBackBrandPage={() => this.navigateTo('brandPage')}
              onBackRating={() => this.navigateTo('ratingPage')}
            />
        }

        {
          sentence.rating_status === 'complete' && sentence.text_status === 'none'
            && <NotGeneratedYet
              title={"No automated sentence has been generated yet, do you want to generate one?"}
              onGenerate={() => this.openAutoSentenceEditor()}
              onBackBrandPage={() => this.navigateTo('brandPage')}
            />
        }

        {
          sentence.rating_status === 'complete' && sentence.text_status === 'complete'
            && (
              <div>
                <h5>Last Saved Sentence</h5>
                <Form>
                  <TextArea rows={8} readOnly value={sentence.text} />
                  <p>Updated At: <strong>{moments(sentence.updatedAt)}</strong></p>
                </Form>

                {this.state.isEditing
                  ? <SummaryEditor
                    title='Sentence Editor'
                    originalText={sentence.text}
                    onSave={newSentence => this.handleSave(newSentence)}
                    onSaveAndNext={newSentence => this.handleSaveAndNext(newSentence)}
                    onCancel={() => this.handleCancel()}
                  />
                  : !this.state.isGeneratingSentence
                  && (
                    <div className='button-block'>
                      <button onClick={() => { this.openEditor(); }}>Edit Current Sentence</button>
                      <button className='float-left' onClick={() => { this.openAutoSentenceEditor(); }}>Generate AutoSentence</button>
                    </div>
                  )
                }
              </div>
            )
        }

        {
          this.state.isGeneratingSentence
            && <AutoSentence
              brandId={this.brandId}
              onSave={sentenceText => this.handleSave(sentenceText)}
              onSaveAndNext={sentenceText => this.handleSaveAndNext(sentenceText)}
              onCancel={() => this.handleCancel()}
            />
        }
      </div>   
    )
  }
}

LargeBrandSentenceEditor.propTypes = {
  sentence: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default withRouter(LargeBrandSentenceEditor);


// WEBPACK FOOTER //
// ./src/components/Sentences/LargeBrandSentenceEditor.js